import React, { createContext, useState } from 'react';
import axios from 'axios';
import config from '../config/config'

export const ListingContext = createContext();

export function ListingProvider(props) {

  const [listings, setListings] = useState([])
  const [publishedListings, setPublishedListings] = useState([])
  const [listingsSearch, setListingsSearch] = useState([])
  const [listingCount, setListingCount] = useState(0)
  const [featured, setFeatured] = useState([])
  const [page, setPage] = useState(1)

  const getListings = async (page, size = 15) => {
    try {
      const response = await axios.get(`${config.apiUrl}/api/listing/paginated/${page}/${size}`);
      if (size !== 'all') setListings(response.data);
      return response.data;
    } catch (err) {
      console.log(err);
      throw err;
    }
  }

  const getPublishedListings = async (page) => {
    try {
      const response = await axios.get(`${config.apiUrl}/api/listing/published`);
      setPublishedListings(response.data);

    } catch (err) {
      console.log(err);
    }
  }

  const getListingCount = async () => {
    try {
      const response = await axios.get(`${config.apiUrl}/api/listing/count`);
      setListingCount(response.data);

    } catch (err) {
      console.log(err);
      throw err;
    }
  }

  const getFeatured = async () => {
    try {
      const response = await axios.get(`${config.apiUrl}/api/listing/featured`);
      setFeatured(response.data);

    } catch (err) {
      console.log(err);
    }
  }

  const searchListing = async (string) => {
    try {
      const response = await axios.get(`${config.apiUrl}/api/listing/search/${string}`);
      setListingsSearch(response.data);
    } catch (err) {
      console.log(err);
      throw err;
    }
  }

  const createListing = async (data, searchString = '') => {
    try {
      const response = await axios.post(`${config.apiUrl}/api/listing/create`, { ...data });
      if (searchString) {
        await searchListing(searchString).catch(() => {});
      } else {
        await getListings(page).catch(() => {});
        await getListingCount().catch(() => {});
      }
      return response;
    } catch (err) {
      console.log(err);
      throw err;
    }
  }

  const editListing = async (id, data, searchString, page) => {
    try {
      const response = await axios.put(`${config.apiUrl}/api/listing/edit-cms/${id}`, data);
      if (searchString) {
        await searchListing(searchString).catch(() => {});
      } else {
        await getListings(page).catch(() => {});
        await getListingCount().catch(() => {});
      }
      return response;
    } catch (err) {
      console.log(err);
      throw err;
    }
  }

  const publishListing = async (id, bool, searchString) => {
    try {
      const response = await axios.put(`${config.apiUrl}/api/listing/change-publish/${id}`, { publish: bool });
      if (searchString) {
        await searchListing(searchString).catch(() => {});
      } else {
        await getListings(page).catch(() => {});
        await getListingCount().catch(() => {});
      }
    } catch (err) {
      console.log(err);
      throw err;
    }
  }

  const updateFeatured = async (featured) => {
    try {
      await axios.put(`${config.apiUrl}/api/listing/remove-featured`);

      for (let index = 0; index < featured.length; index++) {
        let selected = featured[index]
        let tour = publishedListings.find(e => e.name === selected.listing)
        if (!tour) continue

        let data = {
          isFeaured: true,
          featuredOrder: selected.order
        }
        const response = await axios.put(`${config.apiUrl}/api/listing/edit-cms/${tour._id}`, data);
      }

      getFeatured()
    } catch (err) {
      console.log(err);
    }
  }

  const deleteListing = async (id, searchString) => {
    try {
      const response = await axios.post(`${config.apiUrl}/api/listing/delete/${id}`);
      console.log(response);
      if (searchString) {
        await searchListing(searchString).catch(() => {});
      } else {
        await getListings(page).catch(() => {});
        await getListingCount().catch(() => {});
      }
    } catch (err) {
      console.log(err);
      throw err;
    }
  }

  return (
    <ListingContext.Provider
      value={{
        getListings,
        listings,
        getPublishedListings,
        publishedListings,
        getFeatured,
        featured,
        getListingCount,
        listingCount,
        searchListing,
        listingsSearch,
        createListing,
        editListing,
        publishListing,
        updateFeatured,
        page,
        setPage,
        deleteListing
      }}
    >
      {props.children}
    </ListingContext.Provider>
  );
}
